import { Injectable } from '@angular/core';
import { DataService } from './data.service';
import { environment } from 'src/environments/environment';

@Injectable()
export class PaymentService {

  constructor(private dataService: DataService) {
  };
  
  checksum() {
    return this.dataService.getData('/api/checksum', true).map(res => {
      return res;
    });
  }

  payFee(data: any) {
    return this.dataService.postWithoutBaseUrl(`${environment.authLessBaseUrl}/paygov/bank/send`, data).map(res => {
      return res;
    });
  }

  downloadChallan(payload: any){
    let data = {
      "ref_no":"65d5e6c3c1f7c",
      "payment_type":2
    }
    return this.dataService.post('/echallan/challan/download', payload).map(res => {
      return res;
    });
  }

  cancelTransaction(data: any) {
    return this.dataService.post('/echallan/cancel/transaction', data).map(res => {
      return res;
    });
  }

  getUmpOrders() {
    return this.dataService.getRecord('/api/ump/orders');
  }

  getUmpOrderDetails(orderId: string) {
    return this.dataService.getRecord(`/api/ump/order-details?order_id=${orderId}`);
  }

  getUmpPayUrl(orderId: string): string {
    return `${environment.apiBaseUrl}/api/ump/order/${orderId}/pay`;
  }

}
